import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { string, number } from 'prop-types';
import { BrowseAndSearchMobile } from './BrowseAndSearchMobile';

const browseDefaultVariables = {
  skipInstallServices: false,
  skipSpecificationGroup: false
};

export const BrowseAndSearchMobileContainer = (props) => {

  const { pageType, searchTimeout } = props;
  const searchSkipFn = ({ skip, queryName, attributes }) => {
    if (queryName === 'searchStreamProduct') {
      if (!attributes?.searchModel?.products?._children?.fulfillment) return true;
    }
    return skip;
  };

  const searchOptsFn = ({ options, queryName }) => {
    if (queryName === 'searchStreamProduct') {
      const variables = options.variables;
      // eslint-disable-next-line no-param-reassign
      options.variables = undefined;
    }

    if (queryName === 'searchModel') {
      let to = 3000;
      if (searchTimeout) {
        if (typeof searchTimeout === 'string') {
          to = parseInt(searchTimeout, 10);
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(to)) {
            to = 3000;
          }
        } else if (typeof searchTimeout === 'number') {
          to = searchTimeout;
        }
      }

      // eslint-disable-next-line no-param-reassign
      options.context = {
        ...(options.context || {}),
        timeout: to
      };
    }

    return options;
  };

  if (pageType === 'browse') {
    return (
      <QueryProvider
        skip={searchSkipFn}
        queryOptions={searchOptsFn}
        defaultVariables={browseDefaultVariables}
        cacheKey="browse-search-mobile"
      >
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <BrowseAndSearchMobile {...props} />
      </QueryProvider>
    );
  }

  return (
    <QueryProvider
      defaultVariables={browseDefaultVariables}
      forceClientQueriesOnServer={['searchModel', 'product']}
      cacheKey="browse-search-mobile"
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <BrowseAndSearchMobile {...props} />
    </QueryProvider>
  );

};

BrowseAndSearchMobileContainer.propTypes = {
  pageType: string.isRequired,
  searchTimeout: string,
  productPodHoverDelay: number
};

BrowseAndSearchMobileContainer.defaultProps = {
  searchTimeout: null,
  productPodHoverDelay: 500
};
